import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <p>© 2026 Perry Dasilva. Built one small project at a time.</p>
    </footer>
  );
}

export default Footer;